window.MSSVerifiedFacts = [
  {
    "brand": "Allen-Bradley",
    "mpn": "1747-L551",
    "kind": "plc",
    "scope": "model",
    "summary": "SLC 5/05 processor for the modular SLC 500 platform.",
    "verifiedOn": "2026-09-08",
    "identitySource": "slc-install",
    "fields": [
      {
        "label": "Device type",
        "value": "PLC processor",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Memory",
        "value": "16K words",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Communications",
        "value": "Ethernet and RS-232",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Power arrangement",
        "value": "Powered through the SLC chassis backplane",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      }
    ],
    "sources": [
      {
        "id": "slc-install",
        "title": "Rockwell Automation · 1747-IN009B-EN-P, pp. 7–9, 12–13",
        "url": "https://literature.rockwellautomation.com/idc/groups/literature/documents/in/1747-in009_-en-p.pdf"
      }
    ]
  },
  {
    "brand": "Allen-Bradley",
    "mpn": "1747-L552",
    "kind": "plc",
    "scope": "model",
    "summary": "SLC 5/05 processor for the modular SLC 500 platform.",
    "verifiedOn": "2026-09-08",
    "identitySource": "slc-install",
    "fields": [
      {
        "label": "Device type",
        "value": "PLC processor",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Memory",
        "value": "32K words",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Communications",
        "value": "Ethernet and RS-232",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Power arrangement",
        "value": "Powered through the SLC chassis backplane",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      }
    ],
    "sources": [
      {
        "id": "slc-install",
        "title": "Rockwell Automation · 1747-IN009B-EN-P, pp. 7–9, 12–13",
        "url": "https://literature.rockwellautomation.com/idc/groups/literature/documents/in/1747-in009_-en-p.pdf"
      }
    ]
  },
  {
    "brand": "Allen-Bradley",
    "mpn": "1747-CP3",
    "kind": "cable",
    "scope": "model",
    "summary": "Serial cable used to connect SLC processors to a computer.",
    "verifiedOn": "2026-09-08",
    "identitySource": "slc-install",
    "fields": [
      {
        "label": "Device type",
        "value": "Programming / communication cable",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Interface",
        "value": "RS-232",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Supported processors",
        "value": "SLC 5/03, SLC 5/04 and SLC 5/05",
        "source": "slc-install",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      }
    ],
    "sources": [
      {
        "id": "slc-install",
        "title": "Rockwell Automation · 1747-IN009B-EN-P, pp. 7–9, 12–13",
        "url": "https://literature.rockwellautomation.com/idc/groups/literature/documents/in/1747-in009_-en-p.pdf"
      }
    ]
  },
  {
    "brand": "Allen-Bradley",
    "mpn": "2711-M3A19L1",
    "kind": "hmi",
    "scope": "model",
    "summary": "PanelView 300 Micro operator terminal.",
    "verifiedOn": "2026-09-08",
    "identitySource": "panelview-manual",
    "fields": [
      {
        "label": "Device type",
        "value": "Human-machine interface (HMI)",
        "source": "panelview-manual",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Operator input",
        "value": "Keypad",
        "source": "panelview-manual",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Communications",
        "value": "RS-232 port using DH-485",
        "source": "panelview-manual",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Power requirement",
        "value": "24V DC input",
        "source": "panelview-manual",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      }
    ],
    "sources": [
      {
        "id": "panelview-manual",
        "title": "Rockwell Automation · 2711-UM014G-EN-P, pp. 18, 26, 63, 183",
        "url": "https://literature.rockwellautomation.com/idc/groups/literature/documents/um/2711-um014_-en-p.pdf"
      }
    ]
  },
  {
    "brand": "Hach",
    "mpn": "DR3900",
    "kind": "instrument",
    "scope": "model family; exact ordering code and included options require confirmation",
    "summary": "Benchtop spectrophotometer for laboratory water analysis.",
    "verifiedOn": "2026-09-08",
    "identitySource": "hach-dr3900",
    "fields": [
      {
        "label": "Device type",
        "value": "Visible-range spectrophotometer",
        "source": "hach-dr3900",
        "verifiedOn": "2026-09-08",
        "scope": "model family; exact ordering code and included options require confirmation"
      },
      {
        "label": "Wavelength range",
        "value": "320–1100 nm",
        "source": "hach-dr3900",
        "verifiedOn": "2026-09-08",
        "scope": "model family; exact ordering code and included options require confirmation"
      },
      {
        "label": "Typical application",
        "value": "Laboratory water analysis",
        "source": "hach-dr3900",
        "verifiedOn": "2026-09-08",
        "scope": "model family; exact ordering code and included options require confirmation"
      }
    ],
    "sources": [
      {
        "id": "hach-dr3900",
        "title": "Hach · DR3900 product documentation (model family)",
        "url": "https://www.hach.com/p-dr3900-laboratory-spectrophotometer-without-rfid-technology/LPV440.99.00002"
      }
    ]
  },
  {
    "brand": "Allen-Bradley",
    "mpn": "194E-E32-1753-6N",
    "kind": "switch",
    "scope": "model",
    "summary": "Three-pole rotary load switch from the Bulletin 194E family for switching industrial circuits.",
    "verifiedOn": "2026-09-08",
    "identitySource": "rockwell-194e-e32-1753-6n",
    "fields": [
      {
        "label": "Device type",
        "value": "IEC load switch",
        "source": "rockwell-194e-e32-1753-6n",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Continuous current",
        "value": "32 A (UL/CSA applications)",
        "source": "rockwell-194e-e32-1753-6n",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Poles",
        "value": "3",
        "source": "rockwell-194e-e32-1753-6n",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Switch operation",
        "value": "OFF–ON, 90° rotation",
        "source": "rockwell-194e-e32-1753-6n",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Installation",
        "value": "Open front / door mounting",
        "source": "rockwell-194e-e32-1753-6n",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Maximum rated AC operating voltage",
        "value": "690 V; load-specific ratings must be checked for the application",
        "source": "rockwell-194e-e32-1753-6n",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      }
    ],
    "sources": [
      {
        "id": "rockwell-194e-e32-1753-6n",
        "title": "Rockwell Automation · 194E-E32-1753-6N product specifications",
        "url": "https://www.rockwellautomation.com/en-us/products/details.194E-E32-1753-6N.html"
      }
    ]
  },
  {
    "brand": "Allen-Bradley",
    "mpn": "5069-L306ERM",
    "kind": "plc",
    "scope": "model",
    "summary": "CompactLogix 5380 programmable controller with Ethernet networking and two-axis motion capability.",
    "verifiedOn": "2026-09-08",
    "identitySource": "rockwell-5069-l306erm",
    "fields": [
      {
        "label": "Device type",
        "value": "PLC controller",
        "source": "rockwell-5069-l306erm",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "User memory",
        "value": "600 KB",
        "source": "rockwell-5069-l306erm",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Communications",
        "value": "EtherNet/IP and USB",
        "source": "rockwell-5069-l306erm",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Ethernet ports",
        "value": "2 × 1 Gb",
        "source": "rockwell-5069-l306erm",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "Motion capability",
        "value": "2 axes",
        "source": "rockwell-5069-l306erm",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      },
      {
        "label": "EtherNet/IP device capacity",
        "value": "16 devices",
        "source": "rockwell-5069-l306erm",
        "verifiedOn": "2026-09-08",
        "scope": "model"
      }
    ],
    "sources": [
      {
        "id": "rockwell-5069-l306erm",
        "title": "Rockwell Automation · 5069-L306ERM product specifications",
        "url": "https://www.rockwellautomation.com/en-us/products/details.5069-L306ERM.html"
      }
    ]
  },
  {
    "brand": "Allen-Bradley",
    "mpn": "1756-L71S",
    "kind": "plc",
    "scope": "model",
    "summary": "GuardLogix 5570 safety controller with separate standard and safety memory.",
    "verifiedOn": "2026-09-09",
    "identitySource": "guardlogix-tech",
    "fields": [
      {
        "label": "Device type",
        "value": "GuardLogix 5570 safety controller",
        "source": "guardlogix-tech",
        "verifiedOn": "2026-09-09",
        "scope": "model"
      },
      {
        "label": "Standard memory",
        "value": "2 MB",
        "source": "guardlogix-tech",
        "verifiedOn": "2026-09-09",
        "scope": "model"
      },
      {
        "label": "Safety memory",
        "value": "1 MB",
        "source": "guardlogix-tech",
        "verifiedOn": "2026-09-09",
        "scope": "model"
      }
    ],
    "sources": [
      {
        "id": "guardlogix-tech",
        "title": "Rockwell Automation · 1756-TD001W-EN-P, GuardLogix 5570 technical specifications",
        "url": "https://literature.rockwellautomation.com/idc/groups/literature/documents/td/1756-td001_-en-p.pdf"
      }
    ]
  },
  {
    "brand": "Allen-Bradley",
    "mpn": "1756-L81E",
    "kind": "plc",
    "scope": "model",
    "summary": "ControlLogix 5580 programmable controller with 3 MB standard memory and an embedded Ethernet port.",
    "verifiedOn": "2026-09-09",
    "identitySource": "controllogix-tech",
    "fields": [
      {
        "label": "Device type",
        "value": "ControlLogix 5580 PLC controller",
        "source": "controllogix-tech",
        "verifiedOn": "2026-09-09",
        "scope": "model"
      },
      {
        "label": "Standard memory",
        "value": "3 MB",
        "source": "controllogix-tech",
        "verifiedOn": "2026-09-09",
        "scope": "model"
      },
      {
        "label": "Embedded Ethernet",
        "value": "10 / 100 / 1000 Mbps",
        "source": "controllogix-tech",
        "verifiedOn": "2026-09-09",
        "scope": "model"
      },
      {
        "label": "Programming connection",
        "value": "USB 2.0; temporary local programming",
        "source": "controllogix-tech",
        "verifiedOn": "2026-09-09",
        "scope": "model"
      },
      {
        "label": "Mounting",
        "value": "One slot in a ControlLogix chassis",
        "source": "controllogix-tech",
        "verifiedOn": "2026-09-09",
        "scope": "model"
      }
    ],
    "sources": [
      {
        "id": "controllogix-tech",
        "title": "Rockwell Automation · 1756-TD001W-EN-P, pages 18–19",
        "url": "https://literature.rockwellautomation.com/idc/groups/literature/documents/td/1756-td001_-en-p.pdf"
      }
    ]
  }
];
